<template>
  <div class="myTicket">
    <div class="cart orderList">
      <h1 class="boxTitle mb15 notranslate">
        <router-link v-if="isPackage"
          :to="{ name: 'myTicket', params: { ...$route.params, package: 'package' } }"
          class="btnMypackage">
          {{ locale.mypackage_history }}
        </router-link>
        {{ locale.ticket_detail_info }}
      </h1>
      <div class="ticketDetail" :data-status="status">
        <div class="ticketSection ticketName">
          <p class="ticketStatus">{{ getTicketStatus(status).label }}</p>
          {{ ticketName && ticketName[lang] }}
        </div>
        <div v-if="status === 'UNUSED' && ticketDateInfo" class="ticketSection ticketInfo">
          <div v-if="ticketDateInfo.displayDatetime">
            <div class="label colorGrey">{{ locale.validity_period }}</div>
            <div class="ticketDate">
              <div class="start">
                {{ locale.start }}: 
                <span class="date">{{ ticketDateInfo.displayDatetime.start.date }}</span>
                <span class="time">{{ ticketDateInfo.displayDatetime.start.time }}</span>
              </div>
              <div class="end">
                {{ locale.end }}: 
                <span class="date">{{ ticketDateInfo.displayDatetime.end.date }}</span>
                <span class="time">{{ ticketDateInfo.displayDatetime.end.time }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="status === 'USED'" class="ticketSection ticketInfo">
          <div class="label colorGrey">{{ locale.date_of_use }}</div>
          <div class="value">{{ setDateTimeFormat(usedDate) }}</div>
        </div>
        <div v-else-if="status === 'CANCELLED'" class="ticketSection ticketInfo">
          <div class="label colorGrey">{{ locale.cancellation_date }}</div>
          <div class="value">{{ setDateTimeFormat(cancelDate) }}</div>
        </div>
        <div class="ticketSection ticketCode colorGrey">
          <div class="statusMessage notranslate">
            <p v-if="ticketDateInfo.isBeforeToday" class="message">
              {{ locale.message_ticket_is_before_today }}<br />{{ mesageTicketIsBeforeToday() }}
            </p>
            <p v-else-if="ticketDateInfo.isAfterToday" class="message">
              {{ locale.message_ticket_is_after_today }}
            </p>
            <p v-else-if="!ticketDateInfo.canUseNow" class="message">{{ getTicketStatus(status).message }}</p>
            <p v-else-if="ticketDateInfo.canUseNow && status === 'UNUSED' && !codeNo" class="message">{{ locale.message_ticket_code_nodata }}</p>
            <p v-else class="message">{{ getTicketStatus(status).message }}</p>
          </div>
          <div v-if="ticketDateInfo.canUseNow && status === 'UNUSED' && codeNo">
            <vue-qrcode v-if="codeType === 'QR'"
              :value="codeNo"
              :scale="7" />
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import moment from 'moment/moment'
import { DateTime } from 'luxon'
import VueQrcode from 'vue-qrcode'

export default {
  name: 'TicketDetail',
  props: [
    'lang',
    'ln',
    'locale',
    'isPublic',
    'guestTicketId'
  ],
  components: {
    VueQrcode
  },
  computed: {
    isPackage () {
      return this.$route.params.package
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    dateFormat () {
      return this.$store.getters['common/getDateFormat']
    },
    format () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      const time = 'HH:mm:ss'
      return `${date} ${time}`
    },
    ticketDateInfo () {
      const dateFormat = this.dateFormat
      const startDate = this.startDate
      const endDate = this.endDate
      // const startDate = moment('2025-07-11')
      // const endDate = moment('2025-07-12')
      const usedDate = this.usedDate
      const status = this.status
      const canUseNow = moment().isBetween(startDate, endDate)
      const isBeforeToday = moment().isBefore(startDate) // 시작일 이전인가?
      const isAfterToday = moment().isAfter(endDate) // 만료일이 지났나?
      const start = {
        date: moment(startDate).format(dateFormat.toUpperCase()),
        time: moment(startDate).format('HH:mm')
      }
      const end = {
        date: moment(endDate).format(dateFormat.toUpperCase()),
        time: moment(endDate).format('HH:mm')
      }

      return status === 'UNUSED' && {
        canUseNow: canUseNow,
        isAfterToday: isAfterToday,
        isBeforeToday: isBeforeToday,
        displayDatetime: {
          start: start,
          end: end
        }
      }
    }
  },
  async created () {
    if (this.guestTicketId) {
      await this.getTicketDetail()
    } else {
      alert('티켓정보를 불러올 수 없습니다.')
      this.$router.push({
        name: 'mypackage'
      })
    }
  },
  data () {
    return {
      ticketType: '', // DURATION: 기간내 이용, QUANTITY: 횟수내 이용
      ticketName: null,
      expireat: '',
      status: '', // UNUSED, USED, CANCELLED
      codeType: 'QR', // QR, BARCODE, COUPON, ...
      codeNo: '',
      startDate: null,
      endDate: null,
      usedDate: null,
      cancelDate: null
    }
  },
  methods: {
    setDateTimeFormat (iso) {
      const submitAt = DateTime.fromISO(iso || moment().toISOString(), { zone: this.timezone })
      return submitAt.toFormat(this.format)
    },
    mesageTicketIsBeforeToday () {
      let message = this.locale.message_ticket_use_date
      const startDate = this.ticketDateInfo.displayDatetime.start.date
      return message.replace('{var}', startDate)
    },
    async getTicketDetail () {
      this.$store.commit('loading', true)
      const res = await this.$store.dispatch('ticket/getTicketDetail', this.guestTicketId)
      const ticketInfo = res && res.message
      if (ticketInfo) {
        this.ticketType = ticketInfo.ticketType
        this.ticketName = ticketInfo.content && ticketInfo.content.linkContent
        this.status = ticketInfo.status
        // this.status = 'CANCELLED'
        this.codeType = ticketInfo.codeType
        this.codeNo = ticketInfo.codeNo
        this.startDate = ticketInfo.startat
        this.endDate = ticketInfo.expireat
        this.usedDate = ticketInfo.usedat
        this.cancelDate = ticketInfo.cancelledat
      }

      this.$store.commit('loading', false)
      return res
    },
    getTicketStatus (status) {
      const codeType = this.codeType
      let statusLabel = status
      let statusMessage = null
      if (status === 'UNUSED') {
        statusLabel = this.locale.message_ticket_UNUSED
        if (codeType === 'QR') {
          statusMessage = this.locale.message_use_scan_qr
        }
      } else if (status === 'USED') {
        statusLabel = this.locale.message_ticket_USED
        statusMessage = this.locale.message_ticket_USED
      } else if (status === 'CANCELLED') {
        statusLabel = this.locale.message_ticket_CANCELLED
        statusMessage = this.locale.message_ticket_CANCELLED
      }
      return {
        label: statusLabel,
        message: statusMessage
      }
    }
  }
}
</script>